export function MapSection() {
  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">
            Find Us in <span className="text-gradient-gold">North New Jersey</span>
          </h2>
          <p className="text-muted-foreground">
            Proudly serving Passaic, Bergen, Essex, and Morris Counties
          </p>
        </div>

        <div className="rounded-xl overflow-hidden shadow-lg border border-border">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d545155.4311668156!2d-74.72135314522548!3d40.922665030791144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fdfe4c9fca95%3A0xdad63374c7f86ff2!2sMasonry%20Pro%20Construction!5e1!3m2!1sen!2sus!4v1767545080763!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Masonry Pro - Totowa, NJ"
            className="w-full"
          />
        </div>
      </div>
    </section>
  );
}
